<template>
<div class="tab-pane fade" id="AgentAmountReport" role="tabpanel"  aria-labelledby="home-tab">

                <div class="row col-sm-12">
                  
                  <div class="col-sm-12">
                  
                    <div class="form-group "><button @click="showreportotabel()" class="btn btn-primary">Home</button></div>
                   
                   
                  
                  </div>
              

                </div>
  <div class="row" style="overflow-x: auto; white-space: nowrap; ">
      <div class="row col-12" style="padding-bottom:20px;">
      <b-col lg="6" class="">
        <b-form-group
          label="Filter"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInputagentamount"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="filteragentamount"
              type="search"
              id="filterInputagentamount"
              placeholder="Type to Search"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>

        </b-form-group>
      </b-col>

        <b-col sm="3" md="6" class="my-1">
      
      </b-col>
    </div>

    
                      <b-table
                      bordered=true
                      dark=true
                
                      show-empty

                      selectable
                      select-mode="single"
                      selected-variant="primary"
                      :items="indukdatas"
                      :fields="fields"
                      :current-page="currentPage"
                      :per-page="perPage"
                      :filter="filteragentamount"
                      :filterIncludedFields="filterOn"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :sort-direction="sortDirection"
                      @filtered="onFiltered"
                      @row-selected="onRowSelectedMember"
                 
                    >
                 

                      <template v-slot:cell(tot_all)="data" align="center">
                         {{formatPrice(data.value)}}
                      </template>
                      <template v-slot:cell(agent_credit_amount)="data" align="center">
                         {{formatPrice(data.value)}}
                      </template>
                      <template v-slot:cell(client_credit_amount)="data" align="center">
                         {{formatPrice(data.value)}}
                      </template>
                      <template v-slot:cell(not_allocate_credit_amount)="data" align="center">
                         {{formatPrice(data.value)}}
                      </template>
                  
                    
                    </b-table>


                     <div class="row col-6">
    

      <b-col sm="7" md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="indukdatas.length"
          per-page="10"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </div>
                  </div>

           
                <div style="padding-top:30px;">
                  <div class="b-b b-theme nav-active-theme mb-3">
                     <ul class="nav nav-pills" id="myTabchild2">
                        <li class="nav-item">
                        <a 
                        class="nav-link active" 
                        id="reportsa"
                        data-toggle="tab" 
                        href="#childreports_b"
                        role="tab" 
                        aria-controls="home" 
                        aria-selected="true">
                        Inferior Agent Amount Detail
                      </a>
                    </li>

                     
                     </ul>
                   </div>
                   <div class="tab-content mb-4">
                  <div class="tab-pane fade active show" id="childreports_b" role="tabpanel" aria-labelledby="home-tab">

                                <div class="row" style="overflow-x: auto; white-space: nowrap;">
      <div class="row col-12" style="padding-bottom:20px;">
      <b-col lg="6" class="">
        <b-form-group
          label="Filter"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInputchildamount"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="filterchildamount"
              type="search"
              id="filterInputchildamount"
              placeholder="Type to Search"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>

        </b-form-group>
      </b-col>

        <b-col sm="3" md="6" class="my-1">
      
      </b-col>
    </div>

    
                      <b-table
                      bordered=true
                      dark=true
                
                      show-empty

                      selectable
                      select-mode="single"
                      selected-variant="primary"
                      :items="mydatas"
                      :fields="fieldchilds"
                      :current-page="currentPage"
                      :per-page="perPage"
                      :filter="filterchildamount"
                      :filterIncludedFields="filterOn"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :sort-direction="sortDirection"
                      @filtered="onFiltered"
                      @row-selected="onRowSelectedMember"
                 
                    >
                 
                      <template v-slot:cell(action)="row" align="center">
                         <button @click="showreportotabel(row.item.user_id)" class="btn btn-primary">Detail</button>
                      </template>
                      <template v-slot:cell(tot_all)="data" align="center">
                         {{formatPrice(data.value)}}
                      </template>
                      <template v-slot:cell(agent_credit_amount)="data" align="center">
                         {{formatPrice(data.value)}}
                      </template>
                      <template v-slot:cell(client_credit_amount)="data" align="center">
                         {{formatPrice(data.value)}}
                      </template>
                      <template v-slot:cell(not_allocate_credit_amount)="data" align="center">
                         {{formatPrice(data.value)}}
                      </template>
                  
                    
                    </b-table>


                     <div class="row col-6">
    

      <b-col sm="7" md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="mydatas.length"
          per-page="10"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </div>
                  </div>

               
                      </div>

                  
                   </div>
                </div>
                </div>
</template>


<script type="text/javascript">
  function testfun(){
    alert("tes");
  }
</script>

<script>


import { mapGetters } from "vuex";
import * as TYPES from "@/store/mutation-types";
import { DataTable,ItemsPerPageDropdown, Pagination  } from 'v-datatable-light'
import Spinner from "vue-simple-spinner";
import api from '@/api'
import Vue from 'vue'


const Edit = Vue.extend({
  template: `<a @click='editProperty' class='btn btn-warning'><i class='fa fa-pencil'></i> Edit</a>`,
  methods:{
    editProperty(){
     // console.log(this.data.name)
     alert("hello")
      this.$emit("edit-property")
    }
  }
});

export default {
  name: "agentamountreport",
 /* data : {
    dataTable:null,
    dataTableAnak:null,
    btngen:null,

  },*/

  data: function() {
    return {
        mydatas : [],
        dataTable:null,
        dataTableAnak:null,
        indukdatas : [],
        fields: [
          { key : 'agent_type', label : 'Class'},
          { key: 'username', label: 'Username', sortable: true,  },
          { key: 'tot_all', label: 'Total Amount',sortable: true,},
          { key: 'agent_credit_amount', label: 'Inferior Agent Credit Amount'},
          { key: 'client_credit_amount', label: 'Inferior Client Credit Amount',sortable: true,},
          { key: 'not_allocate_credit_amount', label: 'Not Allocate Credit Amount'},
          { key: 'client_count', label: 'Client Count'},     
        ],
         fieldchilds: [
          { key : 'action'},
          { key : 'agent_type', label : 'Class'},
          { key: 'username', label: 'Username', sortable: true,  },
          { key: 'tot_all', label: 'Total Amount',sortable: true,},
          { key: 'agent_credit_amount', label: 'Inferior Agent Credit Amount'},
          { key: 'client_credit_amount', label: 'Inferior Client Credit Amount',sortable: true,},
          { key: 'not_allocate_credit_amount', label: 'Not Allocate Credit Amount'},
          { key: 'client_count', label: 'Client Count'},     
        ],
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filteragentamount: null,
      filterchildamount : null,
      filterOn: [],
    }
  },
  components: {
    DataTable,
    ItemsPerPageDropdown,
    Pagination,
    Spinner
  },
  computed: {
   ...mapGetters(["allAgentAmountReports","singleUser"]),
   getAllReports(){
      return this.allAgentAmountReports
   },
   getUser(){
      return this.singleUser
   }
  },

  methods : {
    getreport(usid=''){
      let defuser = this.getUser
      let theid = ''
      if (usid == ''){
        theid = defuser.user_id;
      } else {
        theid = usid;
      }

       let par = {
           id : theid
        }

        this.$store.dispatch(TYPES.FETCH_AGENTAMOUNTREPORT, par)
        //debugger;
    },
    formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    showreportotabel(usid=''){
    //  debugger;
   //   this.getreport(usid);
   let defuser = this.getUser
   let theid = ''
   if (usid == ''){
        theid = defuser.user_id;
      } else {
        theid = usid;
      }

    //  $("#mb-load").modal();

     api.get('agent/amountreport?user_id='+theid).then(({ data }) => {
      var thearr = data.data;
   

      this.mydatas = [];
      this.indukdatas = [];

      //this.indukdatas.push(thearr)
      
      if (thearr){
          var childs = thearr.children;

          thearr.tot_all = thearr.agent_credit_amount+thearr.client_credit_amount+thearr.not_allocate_credit_amount;
       

          this.indukdatas.push(thearr);



          for (var i = childs.length - 1; i >= 0; i--) {

              childs[i].tot_all = childs[i].agent_credit_amount+childs[i].client_credit_amount+childs[i].not_allocate_credit_amount;
             // debugger;
              this.mydatas.push(childs[i]);
           
          }

       //   $("#mb-load").modal('hide');
         
         // $('#tabelanak').DataTable().ajax.reload();
          
          //debugger;
      }
     
    })
  }
  },
  created(){
   /* let defuser = this.getUser
    let par = {
           id : defuser.user_id
        }

    this.$store.dispatch(TYPES.FETCH_AGENTAMOUNTREPORT, par)*/
  },
  mounted(){
  //  this.dataTable = $('#tableinduk').DataTable({}); 
    this.dataTableAnak = $(this.$refs.childsTable).DataTable({});
    setTimeout(() => this.mydatas = fakeData(50), 1000);

    this.showreportotabel();
   // this.getreport();

   // this.dataTableAnak = $('#tabelanak').DataTable({}); 
   // this.showreportotabel();

  /*  this,dataTable.on("draw.dt", function(){
      $(".edit-placeholder").each(function(i, el){
          const data = table.api().cell( $(this).closest("td") ).data();
          new Edit({data:{data}}).$mount(el)
      })
    })*/

  },
  watch: {
  mydatas(val) {
    this.dataTableAnak.destroy();
    this.$nextTick(() => {
      this.dataTableAnak = $(this.$refs.childsTable).DataTable()
    });
  }
},
};

</script>